import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/rc-calendar/es/index.js
// module id = 1100
// module chunks = 0